export default "__VITE_ASSET__DZoVWqj3__"